<div class="report-create-report">
  <app-loader *ngIf="isLoading"></app-loader>
  <div class="create-report-type">
    <h2 class="title">Create Report</h2>
    <div class="custom-stepper">
      <div class="step" [class.active]="step() === 1" [class.done]="step() !== 1">
        <div class="circle">
          <div class="initial-center">1</div>
        </div>
        <div class="label">Initiate</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="step() === 2">
        <div class="circle">
          <div class="initial-center">2</div>
        </div>
        <div class="label">Generate</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="step() === 3">
        <div class="circle">
          <div class="initial-center">3</div>
        </div>
        <div class="label">Review</div>
      </div>
      <div class="line"></div>
      <div class="step" [class.active]="step() === 4">
        <div class="circle">
          <div class="initial-center">4</div>
        </div>
        <div class="label">Approved</div>
      </div>
    </div>
  </div>
  <div class="report-form">
    <p class="help-text">To start, please make selections to help to find a report quicker...</p>
    <form [formGroup]="options">
      <div class="form-container">
        <app-searchable-dropdown label="Client Name" [items]="clients()" bindLabel="clientName"
          bindValue="clientId" placeholder="Select Client" errorMessage="Client is required"
          formControlName="clientName">
        </app-searchable-dropdown>

        <div>
          <label for="projectID">Project Number <span class="required">*</span></label>
          <input type="text" numbersOnly inputmode="numeric" id="projectID" formControlName="projectID"
            placeholder="Enter Project Number" maxlength="8">
          <div class="error-message" *ngIf="options.get('projectID')?.touched && options.get('projectID')?.hasError('required')">
            {{ validationMessages.CREATE_GENERATE_REPORT.PROJECT_ID_REQUIRED }}
          </div>
          <div class="error-message" *ngIf="options.get('projectID')?.touched && options.get('projectID')?.hasError('maxlength')">
            {{ validationMessages.CREATE_GENERATE_REPORT.PROJECT_ID_MAX_LENGTH }}
          </div>
        </div>

       <app-searchable-dropdown label="Report Type" [items]="reportTypes()" bindLabel="reportTypeName"
          bindValue="id" placeholder="Select Report Type" errorMessage="{{validationMessages.CREATE_GENERATE_REPORT.REPORT_TYPE_REQUIRED }}"
          formControlName="reportType">
        </app-searchable-dropdown>

        <div>
          <label for="reportMonth">Reference Report Month</label>
          <app-month-picker id="reportMonth" formControlName="reportMonth"></app-month-picker>
          <div class="error-message" *ngIf="options.get('reportMonth')?.touched && options.get('reportMonth')?.invalid">
            {{ validationMessages.CREATE_GENERATE_REPORT.REPORT_MONTH_REQUIRED }}
          </div>
        </div>

        <app-searchable-dropdown label="Site/Location Name" [items]="locations()" bindLabel="locationName"
          bindValue="locationId" placeholder="Select Site/Location Name" errorMessage="{{ validationMessages.CREATE_GENERATE_REPORT.LOCATION_REQUIRED }}"
          formControlName="sitelocationname">
        </app-searchable-dropdown>


        <app-searchable-dropdown label="State" [items]="satates()" bindLabel="stateName"
          bindValue="stateId" placeholder="Select State" errorMessage="{{ validationMessages.CREATE_GENERATE_REPORT.STATE_REQUIRED }}"
          formControlName="stateName">
        </app-searchable-dropdown>

      </div>
      <div class="actions">
        <button type="button" class="cancel-button aecom_btn" (click)="onReset()">Reset</button>
        <button type="submit" class="aecom_btn--solid" (click)="findReports($event)">Find
          Report</button>
      </div>
    </form>
  </div>
  <br>
  @if (searchResults().length > 0) {

  <div>
    <h2><span class="report-count">{{searchResults().length}}</span>&nbsp; Reports Found</h2>
  </div>
  <div class="results-table">
    <table>
      <tbody>
        @for (report of searchResults(); track report.id) {
        <tr (click)="selectReport(report)">
          <td class="radio-col">
            <input type="radio" [id]="'report-' + report.id" name="reportSelect" [value]="report.id"
              [checked]="selectedFileId === report.fileId">
          </td>
          <td>{{report.reportName}}</td>
          <td>{{report.projectId}}</td>
          <td>{{report.createdDate | date: 'MM/dd/yyyy'}}</td>
          <td>{{report.locationName}}</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  }
  @if (searchResults().length > 0) {
  <div class="page-action">
    <button type="button" class="aecom_btn" (click)="onCancel()">Cancel</button>
    <button type="button" class="aecom_btn--solid" (click)="generateReport()"
      [disabled]="isNextButtonDiabled">Next</button>
  </div>
  }
</div>

<div class="dialog-overlay" *ngIf="isMessageDialogOpen">
  <div class="dialog-box">
    <div class="dialog-header">
      <h2 class="dialog-title">{{ dialogTexts.FILTER_ERRORS.TITLE }}</h2>
      <button class="close-btn" aria-label="Close" (click)="closeMessageDialog()">
        &times;
      </button>
    </div>

    <div class="dialog-body">
      <ng-content>
        <p class="dialog-message" *ngIf="filterErrorMessages" [innerHTML]="filterErrorMessages"></p>
      </ng-content>
    </div>
    <div class="dialog-actions">
      <button class="aecom_btn" (click)="closeMessageDialog()">Close</button>

    </div>
  </div>
</div>